import React from "react";
import { SmallBezierSvg } from "../svg/SmallBezierSvg";
import IconTrash from "./icons/IconTrash";
import IconStar from "./icons/IconStar";

function cubicBezier([n1, n2, n3, n4]: number[]) {
	return `cubic-bezier(${n1}, ${n2}, ${n3}, ${n4})`;
}

interface PresetItemProps {
	index: number;
	value: number[];
	name: string;
	isFavorite?: boolean;
	isStandard?: boolean;
	disallowFavorite?: boolean;
	handleFavoriteClick: (name: string) => void;
	handleSVGClick: (value: number[]) => void;
	deleteCustomPreset?: (name: string) => void;
}

export const PresetItem: React.FC<PresetItemProps> = ({
	index,
	value,
	name,
	handleSVGClick,
	deleteCustomPreset,
	isFavorite,
	isStandard,
	disallowFavorite,
	handleFavoriteClick,
}) => {
	return (
		<div className="overflow-ellipsis w-10 h-fit cursor-pointer group transform transition-transform duration-150">
			<div
				className="relative"
				id={index.toString()}
				onClick={(e) => {
					console.log("click");
					e.stopPropagation();
					e.preventDefault();
					handleSVGClick(value);
				}}
			>
				<div className="transition-transform duration-150 group-hover:scale-[1.05]">
					<SmallBezierSvg
						// @ts-ignore
						displayValue={value}
						// onClick={() => handleSVGClick(value)}
						id={index.toString()}
					/>
				</div>
				{!isStandard && deleteCustomPreset && (
					<div
						className="cursor-pointer absolute -top-2 left-3 w-3.5 h-3.5 opacity-70 hover:opacity-100 hover:scale-125 group-hover:text-red text-transparent"
						onClick={(e) => {
							e.stopPropagation();
							deleteCustomPreset(name);
						}}
						data-name={name}
						data-index={index}
					>
						<IconTrash />
					</div>
				)}
				<div
					onClick={(e) => {
						e.stopPropagation();
						handleFavoriteClick(name);
					}}
					className={`absolute -top-2 -left-1 w-3.5 h-3.5 opacity-70 hover:opacity-100 hover:scale-125 group-hover:text-blue text-transparent`}
				>
					<IconStar fill={isFavorite} />
				</div>
			</div>
			<span
				className="block w-full text-xs text-center text-highlight1 group-hover:text-highlight2 leading-3 mt-1"
				title={name}
			>
				{name}
			</span>
		</div>
	);
};
